import { gql } from '@apollo/client';

export const GET_CARTS = gql`
  query CART_SERVICE_V2_getCartsBy($groupId: String) {
    getCartsBy(groupId: $groupId) {
      id
      groupId
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

export const GET_CART = gql`
  query CART_SERVICE_V2_getCart($id: ID!) {
    getCart(id: $id) {
      id
      groupId
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      rateSegment
      premiumCostAnswers
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

export const CREATE_CART = gql`
  mutation CART_SERVICE_V2_createCart(
    $groupId: String
    $cartSource: CartSource
    $browsingCriteria: Map
    $name: String
    $rateSegment: RateSegment
  ) {
    createCart(
      groupId: $groupId
      cartSource: $cartSource
      browsingCriteria: $browsingCriteria
      name: $name
      rateSegment: $rateSegment
    ) {
      id
      groupId
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

// Add portfolio variant on Browsing page to the Cart
export const ADD_PORTFOLIO_TO_CART = gql`
  mutation CART_SERVICE_V2_addPortfolioConfigToCart($portfolioConfigRequest: PortfolioConfigRequest) {
    addPortfolioConfigToCart(portfolioConfigRequest: $portfolioConfigRequest) {
      id
      groupId
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      rateSegment
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

// Remove variant, or all variants of the Portfolio on Browsing page from Cart
export const REMOVE_PORTFOLIO_FROM_CART = gql`
  mutation CART_SERVICE_V2_removePortfolioConfigFromCart(
    $cartId: ID!
    $portfolioId: String
    $removeLastActiveBC: Boolean
  ) {
    removePortfolioConfigFromCart(cartId: $cartId, portfolioId: $portfolioId, removeLastActiveBC: $removeLastActiveBC) {
      id
      groupId
      lastUpdateBrowsingCriteria
      lastUpdateTime
      rateSegment
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

export const REMOVE_BC_BY_INDEX = gql`
  mutation CART_SERVICE_V2_removeBCByIndex($cartId: ID!, $portfolioId: String, $index: Int) {
    removeBCByIndex(cartId: $cartId, portfolioId: $portfolioId, index: $index) {
      id
      groupId
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

// Save on Browsing page
export const SAVE_PROPOSAL = gql`
  mutation CART_SERVICE_V2_saveProposal($cartId: ID!, $cartName: String) {
    saveProposal(cartId: $cartId, cartName: $cartName) {
      id
      groupId
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      rateSegment
      premiumCostAnswers
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

// Update BC that used to show Portfolios which possible to add on Browsing page
export const UPDATE_BC = gql`
  mutation CART_SERVICE_V2_updateLastBC($cartId: ID!, $browsingCriteria: Map) {
    updateLastBC(cartId: $cartId, browsingCriteria: $browsingCriteria) {
      id
      lastUpdateBrowsingCriteria
      lastUpdateTime
      cartName
      creationDateTime
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

export const COPY_CART = gql`
  mutation CART_SERVICE_V2_copyCart($id: ID!, $name: String) {
    copyCart(id: $id, name: $name) {
      id
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      rateSegment
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

export const CONFIRM_CART_ITEMS = gql`
  mutation CART_SERVICE_V2_confirmCartItems($cartId: ID!, $portfolioIdToSelectIndex: Map) {
    confirmCartItems(cartId: $cartId, portfolioIdToSelectIndex: $portfolioIdToSelectIndex) {
      id
      groupId
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      rateSegment
      premiumCostAnswers
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

// get proposal templates
export const GET_BROKER_CARTS_BY_SEGMENT = gql`
  mutation CART_SERVICE_V2_getBrokerCartsBySegment($rateSegment: RateSegment, $bc: Map) {
    getBrokerCartsBySegment(rateSegment: $rateSegment, bc: $bc) {
      id
      cartName
      groupId
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      rateSegment
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

export const APPLY_BROKER_CART = gql`
  mutation CART_SERVICE_V2_applyBrokerCart($cartId: ID!, $bc: Map, $groupId: String) {
    applyBrokerCart(cartId: $cartId, bc: $bc, groupId: $groupId) {
      id
      cartName
      groupId
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      rateSegment
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

// Save proposal template
export const SAVE_BROKER_CART = gql`
  mutation CART_SERVICE_V2_saveBrokerCart($cartId: ID!, $name: String, $rateSegment: RateSegment) {
    saveBrokerCart(cartId: $cartId, name: $name, rateSegment: $rateSegment) {
      id
    }
  }
`;

// delete cart on favorite proposals page
export const DELETE_CART = gql`
  mutation CART_SERVICE_V2_deleteCart($id: ID!) {
    deleteCart(id: $id)
  }
`;

export const UPDATE_CART_NAME = gql`
  mutation CART_SERVICE_V2_updateCartName($id: ID!, $name: String!) {
    updateCartName(id: $id, name: $name) {
      id
      cartName
    }
  }
`;

export const SAVE_PREMIUM_COST_ANSWERS = gql`
  mutation CART_SERVICE_V2_savePremiumCostAnswers($cartId: ID!, $premiumCostAnswers: Map!) {
    savePremiumCostAnswers(cartId: $cartId, premiumCostAnswers: $premiumCostAnswers) {
      id
      groupId
      cartName
      premiumCostAnswers
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      rateSegment
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

// Get updated short name for config portfolio logic
export const SAVE_SHORT_NAME_TO_BC = gql`
  mutation CART_SERVICE_V2_saveShortNameToBC($sponsorId: ID!, $bc: Map!) {
    saveShortNameToBC(sponsorId: $sponsorId, bc: $bc)
  }
`;

export const CAN_COMBINE_WITH = gql`
  query CART_SERVICE_V2_canCombineWith(
    $cartId: String!
    $productLineId: String!
    $inPortfolioCartItemIds: [String!]!
    $combinationType: CombinationType!
  ) {
    canCombineWith(
      cartId: $cartId
      productLineId: $productLineId
      inPortfolioCartItemIds: $inPortfolioCartItemIds
      combinationType: $combinationType
    )
  }
`;

export const ADD_DYNAMIC_PORTFOLIO = gql`
  mutation CART_SERVICE_V2_addDynamicPortfolio(
    $cartId: String!
    $portfolioId: String!
    $name: String
    $cartItemIds: [String!]!
    $simplifiedBC: Boolean
  ) {
    addDynamicPortfolio(
      cartId: $cartId
      portfolioId: $portfolioId
      name: $name
      cartItemIds: $cartItemIds
      simplifiedBC: $simplifiedBC
    ) {
      id
      groupId
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;
